'use client'

import PropTypes from 'prop-types'
import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'
import { Logo } from '@repo/ui/Logo'
import { useTheme } from '@mui/material/styles'

export const AuthScreenTitle = ({ title, description }) => {
  const theme = useTheme()

  return (
    <>
      <MUIStack direction="row" alignItems="center" gap={3}>
        <Logo sx={{ width: '64px', height: '64px', color: theme.palette.secondary.dark }} />
        <MUITypography data-testid="authTitle" variant="h2" sx={{ margin: 0 }}>
          {title}
        </MUITypography>
      </MUIStack>
      <MUITypography variant="body1" sx={{ marginBottom: 14 }}>
        {description}
      </MUITypography>
    </>
  )
}

AuthScreenTitle.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string
}
